import axiosInstance from '@/plugins/axios'
import { appApiUrls } from '../constants/apiUrls'

// Dashboard & Clock In/Out APIs
export const getCheckInStatus = () => {
  return axiosInstance.get(appApiUrls.dashboard.checkInStatus)
}

export const updateCheckInStatus = (payload) => {
  return axiosInstance.post(appApiUrls.dashboard.checkInStatus, payload)
}

export const updateCheckInStatusV3 = (payload) => {
  return axiosInstance.post(appApiUrls.dashboard.postCheckInStatus, payload)
}

export const getDailyAttendance = (params) => {
  return axiosInstance.get(appApiUrls.dashboard.dailyAttendance, { params })
}

export const getCaseAnalytics = (params) => {
  return axiosInstance.get(appApiUrls.dashboard.caseAnalytics, { params })
}

export const getCaseStatusAnalytics = () => {
  return axiosInstance.get(appApiUrls.dashboard.caseStatusAnalytics)
}

export const getTaskAnalytics = (params) => {
  return axiosInstance.get(appApiUrls.dashboard.taskAnalytics, { params })
}

export const getCaseStats = (params) => {
  return axiosInstance.get(appApiUrls.dashboard.caseStats, { params })
}

export const saveUserLocation = (payload) => {
  return axiosInstance.post(appApiUrls.dashboard.saveLocation, payload)
}

// Config APIs
export const getOrgConfig = () => {
  return axiosInstance.get(appApiUrls.config.orgConfig, { params: { appType: 'EMP' } })
}

export const getOrgSettings = () => {
  return axiosInstance.get(appApiUrls.config.settings)
}

export const getAttendanceSettings = () => {
  return axiosInstance.get(appApiUrls.config.attendanceSettings)
}

export const getTaskSettings = () => {
  return axiosInstance.get(appApiUrls.config.taskSettings)
}

export const getEmpAppSettings = () => {
  return axiosInstance.get(appApiUrls.config.appSettings)
}

export const getAllUseCases = () => {
  return axiosInstance.get(appApiUrls.config.allUseCases)
}

export const getExtendUseCaseById = (useCaseId) => {
  return axiosInstance.get(`${appApiUrls.config.extendUseCase}/${useCaseId}`)
}

export const getQuestionnaireForm = (formId) => {
  return axiosInstance.get(appApiUrls.config.questionnaireForm, { params: { formId } })
}

export const uploadMeetingAttachment = (formData) => {
  return axiosInstance.post(appApiUrls.task.meetingAttachment, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const getEntities = (params) => {
  return axiosInstance.get(appApiUrls.task.entity, { params })
}

// Task APIs
export const getTaskList = (params) => {
  return axiosInstance.get(appApiUrls.task.tasks, { params })
}

export const getCollectionList = (params) => {
  return axiosInstance.get(appApiUrls.task.collections, { params })
}

export const getCollectionCases = (params) => {
  return axiosInstance.get(appApiUrls.task.collectionCases, { params })
}

export const getTaskById = ({ taskId, isCollection }) => {
  const base = isCollection ? appApiUrls.task.collection : appApiUrls.task.task
  return axiosInstance.get(`${base}/${taskId}`)
}

export const getCollectionCaseById = ({ caseId }) => {
  return axiosInstance.get(`${appApiUrls.task.case}/${caseId}`)
}

export const updateTaskStatus = ({ taskId, isCollection, ...payload }) => {
  const base = isCollection ? appApiUrls.task.collection : appApiUrls.task.updateTask
  return axiosInstance.put(`${base}/${taskId}`, payload)
}

export const updateCaseStatus = ({ caseId, ...payload }) => {
  return axiosInstance.put(`${appApiUrls.task.updateCollection}/${caseId}`, payload)
}

export const createCollectionCase = (payload) => {
  return axiosInstance.post(appApiUrls.task.createCase, payload)
}

export const getCustomers = (params) => {
  return axiosInstance.get(appApiUrls.customer.customers, { params })
}

export const createCustomer = (payload) => {
  return axiosInstance.post(appApiUrls.customer.createCustomer, payload)
}

export const updateCustomer = ({ customerId, ...payload }) => {
  return axiosInstance.put(`${appApiUrls.customer.updateCustomer}/${customerId}`, payload)
}

export const createNewTask = (payload) => {
  return axiosInstance.post(appApiUrls.task.createTask, payload)
}

export const createCollectionCaseTask = (payload) => {
  return axiosInstance.post(appApiUrls.task.createCollection, payload)
}

export const uploadTaskPhoto = (formData) => {
  return axiosInstance.post(appApiUrls.task.photo, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const uploadTaskAudio = (formData) => {
  return axiosInstance.post(appApiUrls.task.audio, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const sendTaskOtp = (payload) => {
  return axiosInstance.post(appApiUrls.task.otp, payload)
}

export const verifyTaskOtp = (payload) => {
  return axiosInstance.post(appApiUrls.task.otpVerification, payload)
}

export const sendTaskLocation = (payload) => {
  return axiosInstance.post(appApiUrls.task.userLocation, payload)
}

export const sendLocationTimeSeries = (payload) => {
  return axiosInstance.post(appApiUrls.task.postLocationTimeSeries, payload)
}

export const getTaskCompletionSteps = () => {
  return axiosInstance.get(appApiUrls.task.steps)
}

export const getWhatsappTemplates = () => {
  return axiosInstance.get(appApiUrls.task.whatsappTemplates)
}

export const sendWhatsappNotification = (payload) => {
  return axiosInstance.post(appApiUrls.task.sendTemplate, payload)
}

// Attendance & Map Services
export const getAttendanceDataV2 = ({ userId, start, end }) => {
  const url = userId ? `${appApiUrls.attendance.attendanceV2}/${userId}` : appApiUrls.attendance.attendanceV2
  return axiosInstance.get(url, { params: { start, end } })
}

export const getLocationOverview = ({ userId, date, start, end }) => {
  const url = userId ? `${appApiUrls.attendance.location}/${userId}` : appApiUrls.attendance.location
  return axiosInstance.get(url, { params: { date, start, end } })
}

export const getLocationTimeSeries = (userId, params) => {
  return axiosInstance.get(`${appApiUrls.user.locationTimeSeries}/${userId}`, { params })
}

// User & Profile Services
export const getUserProfile = () => {
  return axiosInstance.get(appApiUrls.user.profile)
}

export const getUserData = () => {
  return axiosInstance.get(appApiUrls.user.getUser)
}

export const updateUserDetails = ({ userId, ...payload }) => {
  return axiosInstance.put(`${appApiUrls.user.employeeDetails}/${userId}`, payload)
}

export const updateUserProfilePic = (formData) => {
  return axiosInstance.post(appApiUrls.user.profilePic, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const uploadUserAttachment = (formData) => {
  return axiosInstance.post(appApiUrls.user.userAttachment, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const updateEmploymentDetails = ({ id, ...payload }) => {
  return axiosInstance.put(`${appApiUrls.user.employmentDetails}/${id}`, payload)
}

export const setUserLanguage = (language) => {
  return axiosInstance.put(appApiUrls.auth.setLanguage, { language })
}

export const updatePasscode = ({ oldPasscode, passcode }) => {
  return axiosInstance.post(appApiUrls.auth.setPasscode, { oldPasscode, passcode })
}

// KYC Services
export const verifyPanKyc = (payload) => {
  return axiosInstance.post(appApiUrls.kyc.verifyPan, payload)
}

export const sendAadhaarOtp = (payload) => {
  return axiosInstance.post(appApiUrls.kyc.aadhaarOtp, payload)
}

export const verifyAadhaarOtp = (payload) => {
  return axiosInstance.post(appApiUrls.kyc.aadhaarVerify, payload)
}

// Leaves Services
export const getUserLeaveQuota = (params) => {
  return axiosInstance.get(appApiUrls.user.leaveQuota, { params })
}

export const getUserLeaveHistory = (params) => {
  return axiosInstance.get(appApiUrls.user.leaveHistory, { params })
}

export const addNewLeaveRequest = (payload) => {
  return axiosInstance.post(appApiUrls.user.addNewLeaveQuota, payload)
}

export const withdrawLeaveRequest = (requestId, payload) => {
  return axiosInstance.put(`${appApiUrls.user.withdrawLeaveRequest}/${requestId}`, payload)
}

export const getUsersList = (params) => {
  return axiosInstance.get(appApiUrls.user.usersV3, { params })
}
